import React from "react";
import css from "./styles.styl";

const LoadingOverlay = ({ isLoading, children }) => {
    if (!isLoading) return children;

    return (
        <div style={{ position: "relative" }}>
            {children}
            <div className={css.loadingOverlay}>
                <div className={css.loadingContent}>
                    Loading...
                </div>
            </div>
        </div>
    );
};

export default LoadingOverlay;